import React from 'react';
import './Form.css';

export const Form = ({ children, onSubmit, className = '', ...props }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  };

  return (
    <form className={`form ${className}`} onSubmit={handleSubmit} {...props}>
      {children}
    </form>
  );
};

export const FormGroup = ({ children, className = '', ...props }) => {
  return (
    <div className={`form-group ${className}`} {...props}>
      {children}
    </div>
  );
};

export const FormLabel = ({ children, htmlFor, className = '', ...props }) => {
  return (
    <label htmlFor={htmlFor} className={`form-label ${className}`} {...props}>
      {children}
    </label>
  );
};

export const FormInput = ({ 
  type = 'text', 
  id, 
  name, 
  value, 
  onChange, 
  placeholder,
  className = '',
  ...props 
}) => {
  return (
    <input
      type={type}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`form-control ${className}`}
      {...props}
    />
  );
};

export const FormTextarea = ({ 
  id, 
  name, 
  value, 
  onChange, 
  placeholder,
  rows = 3,
  className = '',
  ...props 
}) => {
  return (
    <textarea
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      className={`form-control ${className}`}
      {...props}
    />
  );
};

export const FormSelect = ({ 
  id, 
  name, 
  value, 
  onChange, 
  options = [],
  className = '',
  ...props 
}) => {
  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      className={`form-control ${className}`}
      {...props}
    >
      {options.map(option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
};

export const FormCheck = ({ 
  type = 'checkbox',
  id, 
  name, 
  checked, 
  onChange, 
  label,
  className = '',
  ...props 
}) => {
  return (
    <div className={`form-check ${className}`}>
      <input
        type={type}
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        className="form-check-input"
        {...props}
      />
      {label && (
        <label htmlFor={id} className="form-check-label">
          {label}
        </label>
      )}
    </div>
  );
};